import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-6 px-6">
      <p className="text-sm text-gray-500">요청하신 페이지를 찾을 수 없습니다.</p>
      <div className="flex gap-4 text-sm">
        <Link to="/admin/dispatch" className="text-gray-900 underline underline-offset-4">
          배차 현황
        </Link>
        <Link to="/driver/home" className="text-gray-500 underline underline-offset-4">
          기사 홈
        </Link>
      </div>
    </div>
  );
}
